import React, {useState} from "react";
import { getMarkDown, useDetectMobile } from "../utils";
import '../../../stylesheets/triagebot/EVisitTos_Summary.scss';
import Footer from "./Footer";
import EVisitToastBody from '../../triagebot/dialogs/EVisitToastBody';

const EVisitTos_Summary = ({ message, sendMessage, setToastMessage }) => {

    const [submitted, setSubmitted] = useState(false);
    const [Isloading,setIsLoading] = useState(false);

    const isDisabled = submitted;
    const cdoName = message?.data[0]?.cdoName;
    const headerText = message?.data[0]?.headerText;
    const BeforeData = message?.data[1]?.tosData;
    const feeHeader = message?.data[1]?.feesHeader;
    const FeesData = message?.data[1]?.feesData;
    const popupLinkText = message.data[1]?.popupLinkText;
    const buttons = message?.buttons;

    const agreeButton = buttons[0].displayText;
    const cancelButton = buttons[1].displayText;

    // const EvisitUrl = message?.data[1]?.evisitURL;

    const {isMobile} = useDetectMobile();

    //pop up data
    const popUpData = message?.data[1]?.popupMessageData;

    if (typeof setToastMessage !== 'function')
        setToastMessage = () => { };

    const showToastMessage = () => {
        setToastMessage({
            type: "EVisit",
            header: '',
            body: (
                <EVisitToastBody
                  message={popUpData}
                  cdoName={cdoName}
                /> )
        })
    }

    const cancelPress = ()=>{
        sendMessage('rewind', 'summaryPlaceHolder', 'summaryPlaceHolder');
        sendMessage('message', 'return', 'return');
    }

    const SubmitPress=()=>{
        if(cdoName == 'NWest') {
            setIsLoading(true);
        }
        if(submitted) return;
        setSubmitted(true);
        sendMessage('message', 'Next', 'Next');
        // window.open(`${EvisitUrl}`);
    }

    return (
        <div className={(isDisabled ? 'disabled ': '') + "EVisitTos card"  + (isMobile ? ' mobile' : '')} style={{paddingTop: '8px'}}>
            <div className="terms">{getMarkDown(headerText)}</div>
            
            <div className="TermService">
                {getMarkDown(BeforeData)}
            </div>

            <div className="FeesHeader">
                {getMarkDown(feeHeader)}
            </div>

            <div className="FeesData"> {getMarkDown(FeesData)}</div>

            <div className={(isDisabled ? 'disabled ': '') +'popupLink'} onClick={ ()=> showToastMessage() }>{getMarkDown(popupLinkText)}</div>


            <Footer>
                <button
                    onClick={cancelPress}
                    className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                    disabled={isDisabled}
                >
                    {cancelButton}
                </button>
                <button
                    onClick={SubmitPress}
                    className='continue-button'
                    disabled={isDisabled}
                >
                    {agreeButton}
                </button>
            </Footer>
            {
                Isloading && <div className="loader">
                <svg className="spinner positionDown"  width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                </div>
            }
        </div>
    )
}

export default EVisitTos_Summary;